<template>
  <div class="wrap">
    <div class="wrap">
      <device-list></device-list>
    </div>
  </div>
</template>

<script>
import deviceList from '@/components/page/equipment/deviceList.vue'
export default {
  components: {
    DeviceList,
  },
};
</script>

<style lang="scss" scoped>
.wrap{
    width: 100%;
    height: 100%;
}
</style>